"use client";

type LaserEyesModule = typeof import("@omnisat/lasereyes-core");

let laserEyesModulePromise: Promise<LaserEyesModule> | null = null;
let laserEyesClientPromise: Promise<any> | null = null;

function clearLaserEyesPersistedWalletState(): void {
	if (typeof window === "undefined") {
		return;
	}

	try {
		Object.keys(window.localStorage)
			.filter((key) => key.includes("WALLET_STATE"))
			.forEach((key) => window.localStorage.removeItem(key));
	} catch {
		// Ignore storage cleanup failures in diagnostics path
	}
}

async function loadLaserEyesModule(): Promise<LaserEyesModule> {
	if (!laserEyesModulePromise) {
		laserEyesModulePromise = import("@omnisat/lasereyes-core");
	}

	return laserEyesModulePromise;
}

export async function getLaserEyesClient(): Promise<any> {
	if (!laserEyesClientPromise) {
		laserEyesClientPromise = (async () => {
			const { LaserEyesClient, createStores, createConfig } =
				await loadLaserEyesModule();

			const stores = createStores();
			const config = createConfig({
				network: "mainnet",
			});

			const client = new LaserEyesClient(stores, config);
			await client.initialize();
			return client;
		})();
	}

	return laserEyesClientPromise;
}

export async function connectLaserEyesWallet(
	provider: string,
	options: { forceFreshState?: boolean } = {},
): Promise<{ client: any; storeState: any }> {
	const client = await getLaserEyesClient();
	if (options.forceFreshState) {
		try {
			await client.disconnect();
		} catch {
			// Ignore disconnect errors before a forced reconnect
		}
		clearLaserEyesPersistedWalletState();
	}
	await client.connect(provider);
	return {
		client,
		storeState: client.$store.get(),
	};
}

export async function disconnectLaserEyesWallet(): Promise<void> {
	const client = await getLaserEyesClient();
	await client.disconnect();
}

export async function getLaserEyesStoreState(): Promise<any> {
	const client = await getLaserEyesClient();
	return client.$store.get();
}

export async function getLaserEyesProviderConstant(name: "OKX" | "XVERSE") {
	const laserEyesLib = await loadLaserEyesModule();
	return laserEyesLib[name];
}
